import React from 'react';

const Costs = ({ productInfo }) => {
  if (!productInfo) return <div>No product information available.</div>;
  
  // Helper function to render cost table
  const renderCostTable = (title, costs) => {
    return (
      <div className="mb-6">
        <div className="font-semibold text-lg mb-3 text-gray-800">{title}</div>
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
          <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
            <thead className="bg-[#9B00FB]">
              <tr>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Start Date</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">End Date</th>
                <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Cost</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {costs && Array.isArray(costs) && costs.length > 0 ? (
                costs.map((cost, index) => (
                  <tr key={index} className="hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4 text-sm text-gray-700">{cost.startDate || 'N/A'}</td>
                    <td className="px-6 py-4 text-sm text-gray-700">{cost.endDate || 'N/A'}</td>
                    <td className="px-6 py-4 text-sm text-gray-700">{cost.cost || 'N/A'}</td>
                  </tr>
                ))
              ) : (
                <tr className="hover:bg-gray-50 transition-colors">
                  <td className="px-6 py-4 text-sm text-gray-700">N/A</td>
                  <td className="px-6 py-4 text-sm text-gray-700">N/A</td>
                  <td className="px-6 py-4 text-sm text-gray-700">N/A</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  // Other cost fields
  const otherFields = [
    { key: 'costThreshold', label: 'Cost Threshold for Data Processing' },
    { 
      key: 'sizeThreshold', 
      label: 'Size Threshold for Data',
      specialRender: (value) => {
        if (!value) return 'N/A';
        return `${value.value} ${value.unit}`;
      }
    },
    { key: 'azureServicesCost', label: 'Azure Services Cost' }
  ];

  // Helper function to render a table row
  const renderField = (field) => {
    const value = productInfo[field.key];
    
    return (
      <tr key={field.key} className="hover:bg-gray-50 transition-colors">
        <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
          {field.label}
        </td>
        <td className="px-6 py-4 text-sm text-gray-700">
          {field.specialRender ? field.specialRender(value) : (value || 'N/A')}
        </td>
      </tr>
    );
  };
  
  return (
    <div>
      <h3 className="text-xl font-bold text-gray-800 mb-4">Costs</h3>
      {renderCostTable('Development Costs', productInfo.developmentCosts)}
      {renderCostTable('Support Costs', productInfo.supportCosts)}
      {renderCostTable('Operation Costs', productInfo.operationCosts)}
      
      {/* Other Cost Fields */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <table className="min-w-full bg-white rounded-lg overflow-hidden shadow-sm">
          <thead className="bg-[#9B00FB]">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Label</th>
              <th className="px-6 py-3 text-left text-xs font-medium text-white uppercase tracking-wider">Value</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {otherFields.map(renderField)}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Costs; 